<template>
  <div class="products">
    <h2 class="product-title">
      <div class="titleName">新东方集团</div>
      <div class="PageTurning" v-show="PageTurning">
        <i @click="prePagae"><img src="http://images.xdf.cn/cms20150819/zuixinban/images/arrow_leftoff.png" alt=""></i>
        <i @click="nextPage"><img src="http://images.xdf.cn/cms20150819/zuixinban/images/arrow_rightoff.png" alt=""></i>
      </div>
    </h2>
    <div
      class="product-content"
      v-for="(everyPageList, pageNum) in productLists"
      :key="pageNum"
      v-show="currPage === pageNum"
    >
      <div class="topContent">
        <div
          class="contentItem"
          v-for="(item, index) in everyPageList.topContent"
          :key="index"
        >
            <a :class="['item', item.length === 0 ? 'hide' : '']" :href="item.url" :title="item.organization">
              <div class="itemImg">
                <img :src="item.imgUrl" :alt="item.organization" :style="item.style">
              </div>
              <div class="itemTitle">{{ item.title }}</div>
            </a>
        </div>
      </div>
      <div class="bottomContent">
        <div
          class="contentItem"
          v-for="(item, index) in everyPageList.bottomContent"
          :key="index"
        >
          <a :class="['item', item.length === 0 ? 'hide' : '']" :href="item.url" :title="item.organization">
            <div class="itemImg">
              <img :src="item.imgUrl" :alt="item.organization" :style="item.style">
            </div>
            <div class="itemTitle">{{ item.title }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { products } from 'js/home/products.js'
export default {
  name: 'XdfProduct',
  data () {
    return {
      currPage: 0,
      productLists: []
    }
  },
  computed: {
    PageTurning () {
      if (products.length > 10) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getProductLists()
  },
  methods: {
    nextPage () {
      this.currPage++
      if (this.currPage > this.productLists.length - 1) {
        this.currPage = 0
      }
    },
    prePagae () {
      this.currPage--
      if (this.currPage < 0) {
        this.currPage = this.productLists.length - 1
      }
    },
    getProductLists () {
      let len = Math.ceil(products.length / 10)
      for (let i = 0; i < len; i++) {
        for (let j = i * 10, cnt = 0; j < (i + 1) * 10; j++, cnt++) {
          if (!this.productLists[i]) {
            this.productLists[i] = []
            this.productLists[i].topContent = []
            this.productLists[i].bottomContent = []
          }
          if (!products[j]) {
            products[j] = []
          }
          this.productLists[i].push(products[j])
          if (cnt < 5) {
            this.productLists[i].topContent.push(products[j])
          } else {
            this.productLists[i].bottomContent.push(products[j])
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.products
  width: 1200px
  height: 226px
  margin: 18px auto 0
  display: flex
  flex-direction: column
  .product-title
    flex: 1
    border-bottom: 1px solid #e2e2e2
    .titleName
      float: left
      height: 100%
      font-size: 18px
      line-height: 38px
      color: #333
    .PageTurning
      height: 100%
      line-height: 38px
      float: right
      i
        margin: 0 5px
        cursor: pointer
  .product-content
    flex: 5
    display: flex
    color: #979797
    flex-direction: column
    .topContent
      flex: 1
      display: flex
      clear: both\9\0
      zoom: 1\9\0
      display :block
      .contentItem
        flex: 1
        float:left
        .item
          width: 194px
          height: 78px
          display: flex
          padding: 0 15px
          margin: 0 auto
          position: relative
          top: 50%
          margin-top: -39px
          text-align: center
          flex-direction: column
          border: 1px solid #eee
          background-color: #fff
          margin-right :14px\9\0
          margin-top:10px\9\0
          .itemImg
            flex: 3
            line-height: 46px
            position: relative
            border-bottom: 1px solid #eee
            width:100%\9\0
            height:50px\9\0

            img
              top: 50%
              position: absolute
              margin: 0 auto
          .itemTitle
            flex: 1
            color: #999
            line-height: 22px
        .hide
          visibility: hidden
    .bottomContent
      flex: 1
      display: flex
      .contentItem
        flex: 1
        .item
          width: 194px
          height: 78px
          display: flex
          padding: 0 15px
          margin: 0 auto
          position: relative
          top: 50%
          margin-top: -39px
          text-align: center
          flex-direction: column
          border: 1px solid #eee
          background-color: #fff
          margin-top:19px\9\0
          margin-right:14px\9\0
          .itemImg
            flex: 3
            line-height: 46px
            position: relative
            border-bottom: 1px solid #eee
            width:100%\9\0
            height :50px\9\0
            img
              top: 50%
              position: absolute
              margin: 0 auto
          .itemTitle
            flex: 1
            color: #999
            line-height: 22px
        .hide
          visibility: hidden
</style>



// WEBPACK FOOTER //
// src/pages/home/components/XdfProducts.vue